module.exports = __webpack_public_path__ + "media/images/logo-operator-7bfb49d0bd75a6e3cd93e4b6226793df.png";